<template>
  <div class="p-fluid p-formgrid p-grid">

    <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                       <i class="pi pi-user"></i>
                    </span>
      <InputText id="username" placeholder="Benutzername" v-model="newUser.username"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-lock"></i>
                        </span>
      <Password id="password" placeholder="Passwort" v-model="newUser.password" :feedback="false"></Password>
    </div>

    <div class="p-inputgroup p-mt-2">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-lock"></i>
                        </span>
      <Password id="repeatPassword" placeholder="Passwort wiederholen" v-model="newUser.repeatPassword" :feedback="false"></Password>
    </div>

    <div class="p-inputgroup p-mt-2">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-user"></i>
                        </span>
      <InputText id="name" placeholder="Vorname" v-model="newUser.name"></InputText>
      <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
      <InputText id="surname" placeholder="Nachname" v-model="newUser.surname"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-envelope"></i>
                    </span>
      <InputText id="email" placeholder="Email" v-model="newUser.email"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-envelope"></i>
                    </span>
      <InputText id="street" placeholder="Strasse" v-model="newUser.street"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-user"></i>
                        </span>
      <InputText id="zipCode" placeholder="PLZ" v-model="newUser.zipCode"></InputText>
      <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
      <InputText id="city" placeholder="Ort" v-model="newUser.city"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-phone"></i>
                    </span>
      <InputText id="phone" placeholder="Telefon" v-model="newUser.phone"></InputText>
    </div>

    <div v-if="errorMessage" class="p-col-12 p-mt-2">
      <Message severity="error" :closable="false">{{ errorMessage }}</Message>
    </div>

    <div class="p-mt-2">
      <Button @click="handleSubmit" class="p-button-success p-mr-2" icon="pi pi-check" label="Erstellen"></Button>
      <Button @click="closeDialog" class="p-button-secondary" icon="pi pi-times" label="Abbrechen"></Button>
    </div>

  </div>
</template>

<script>
import UserService from '../services/user.service';

export default {
  name: "CreateUser",
  data() {
    return {
      newUser: {
        username: "",
        password: "",
        repeatPassword: "",
        name: "",
        surname: "",
        email: "",
        street: '',
        zipCode: '',
        city: '',
        phone: ''
      },
      errorMessage: ''
    }
  },
  methods: {
    handleSubmit() {
      // Validierung
      if (!this.newUser.username || !this.newUser.password || !this.newUser.email) {
        this.errorMessage = 'Benutzername, Passwort und Email sind erforderlich!';
        return;
      }

      if (this.newUser.password !== this.newUser.repeatPassword) {
        this.errorMessage = 'Passwörter stimmen nicht überein!';
        return;
      }

      if (this.newUser.password.length < 6) {
        this.errorMessage = 'Passwort muss mindestens 6 Zeichen lang sein!';
        return;
      }

      // Sende die Daten zum Backend
      const userData = {
        username: this.newUser.username,
        password: this.newUser.password,
        email: this.newUser.email,
        name: this.newUser.name,
        surname: this.newUser.surname,
        street: this.newUser.street,
        zipCode: this.newUser.zipCode,
        city: this.newUser.city,
        phone: this.newUser.phone
      };

      UserService.createUser(userData)
          .then(() => {
            this.$toast.add({severity: 'success', summary: 'Erfolg', detail: 'Benutzer erfolgreich erstellt', life: 3000});
            this.$emit('user-created');
            this.closeDialog();
          })
          .catch(error => {
            this.errorMessage = error.response?.data?.message || 'Fehler beim Erstellen des Benutzers';
            console.error(error);
          });
    },
    closeDialog() {
      this.$emit('close-dialog');
    }
  }
}
</script>

<style scoped>

</style>

